module.exports = __webpack_public_path__ + "assets/svg/lesson_modal_ico_2.svg";